export const SET_MODAL_DATA: 'SET_MODAL_DATA' = 'SET_MODAL_DATA';
export const SET_MODAL_ERROR: 'SET_MODAL_ERROR' = 'SET_MODAL_ERROR';
export const CLOSE_MODAL: 'CLOSE_MODAL' = 'CLOSE_MODAL';